import styled from '@emotion/styled';
import React, {
  ChangeEvent,
  CSSProperties,
  InputHTMLAttributes,
  useEffect,
  useState,
} from 'react';

import icCircleXSVG from 'assets/images/ic-circle-x.svg';
import icSearchSVG from 'assets/images/ic-search.svg';

const MobileSearchInput = ({
  icon,
  containerStyle,
  searchIconStyle,
  onClick,
  onChange,
  value = '',
  ...props
}: InputHTMLAttributes<HTMLInputElement> & {
  icon?: string;
  containerStyle?: CSSProperties;
  searchIconStyle?: CSSProperties;
  onClick?: any;
}) => {
  const [inputValue, setInputValue] = useState<any>(value);
  const inputRef = React.useRef<HTMLInputElement>(null);

  const changeHandler = (ev: ChangeEvent<HTMLInputElement>) => {
    setInputValue(ev.target.value);
    onChange && onChange(ev); // optional로 인한 코드
    inputRef?.current?.focus();
  };

  return (
    <Container style={containerStyle}>
      <SearchIcon style={searchIconStyle} src={icSearchSVG} onClick={onClick} />

      <Input value={value} onChange={changeHandler} {...props} ref={inputRef} />
      {inputValue !== '' && (
        <ClearIcon
          src={icCircleXSVG}
          onClick={() => {
            changeHandler({ target: { value: '' } } as any);
          }}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  border-radius: 6px;
  background-color: #fafafa;
  margin-left: 20px;
`;

const Input = styled.input`
  width: 100%;
  padding: 11px 0px 11px 0px;
  background: none;
  border: 0;
  outline: 0;
  &::placeholder {
    color: #999999;
    font-size: 14px;
    letter-spacing: -0.28px;
  }
`;

const SearchIcon = styled.img`
  margin: 0 10px;
`;

const ClearIcon = styled.img`
  margin-right: 12px;
  cursor: pointer;
`;

const Icon = styled.img`
  width: 22px;
  height: 30px;
`;

export default MobileSearchInput;
